import { Box, Center, Container, Text } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import { useAccount } from "wagmi";

export default function App() {
  const { address } = useAccount();

  return (
    <>
      <Box minHeight="100vh">
        <Header />
        {!address && (
          <Center pb="0.5em">
            <Text fontSize="lg" bg="yellow.200" px="1.5em" py="0.5em" borderRadius="0.5em" color="black">
              Connect your wallet to interact with BTFDCA.
            </Text>
          </Center>
        )}
        <Container maxW="7xl" as="main" py="2.5em">
          <Outlet />
        </Container>
      </Box>

      <Footer />
    </>
  );
}
